import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'ramda';

import { Content, Text, Container } from './success.styles';
import { ICON_WINNOW_LOGO } from '../../icon';
import { WhiteIcon } from '../snackbarRender.styles';

export class SuccessComponent extends PureComponent {
  static propTypes = {
    state: PropTypes.string.isRequired,
    message: PropTypes.object.isRequired,
  };

  render() {
    return (
      <Container state={this.props.state}>
        <Content>
          <WhiteIcon name={ICON_WINNOW_LOGO} size={34} />
          <Text>
            <FormattedMessage {...this.props.message} />
          </Text>
        </Content>
      </Container>
    );
  }
}

export const Success = compose(injectIntl)(SuccessComponent);
